<template>
  <div >
    <div class="Platform titleImg">
        <img class="image" src="./Platform/Platform.png" alt="">
    </div>
    <div class=" ">
        <div class="platBox">
            <img class="image" src="./Platform/title.png" alt="">
        </div>

    </div>
    <!-- <div class="Platform Platformtext ">
        <span>企业自建电商平台</span> 已成为当下趋势 时空为您提供从平台规划到上线运营全流程服务
    </div>
    <div class="Platform  PlatformO">
        <img src="./Platform/PlatformO.png" alt="">
    </div>
    <div class="Platform PlatformO ">
        <img src="./Platform/PlatformS.png" alt="">
    </div>
    <div class="Platform PlatformO ">
        <img src="./Platform/PlatformT.png" alt="">
    </div> -->
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
// $sun:75/192;
$sun:100/192;
.Platform{
    display: flex;
    justify-content: center;
    background-color: #FFFFFF;
    width: 100%;
}
.titleImg{
    height: 460px*$sun;
}
.image{
    width: 100%;
    height: 100%;
}

.Platformtext{
    padding:40px*$sun 360px*$sun;
    color: #000;
    font-size: 28px*$sun;
    justify-content: flex-start;
}
.Platformtext{
    display: flex;
    justify-content: center;
}
.Platformtext span{
    color: #FF0000;
}
.PlatformO{
    padding: 0 360px*$sun 40px*$sun 360px*$sun;
}
.platBox{
    width: 1260px*$sun;
    margin: 50px*$sun auto;
}
</style>
